<style scoped>
.cover-shape {
  position: absolute;
  left: 0;
  bottom: 0px;
  width: 100%;
  height: 250px;
  background-image: linear-gradient(
    90deg,
    rgb(255, 129, 103),
    rgb(235, 94, 65)
  );
}
.signin-form {
  min-width: 250px;
}
.signin-form img {
  width: 100%;
  height: 80px;
  object-fit: contain;
}
.cover-shape img {
  /* svg on an img tag */
  transform: rotate(180deg);
  width: 100%;
  position: absolute;
  top: -5px;
  left: 0px;
}
</style>
<template>
  <v-form ref="form" @submit="onSubmit" v-model="valid">
    <v-card class="signin-form" flat>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col class="col-12 justify-center align-center">
            <img
              :src="organizationImg"
              max-height="250"
              width="100%"
              position="center"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-text class="pb-0">
        <v-card-title class="pa-0 ma-0">Sign In</v-card-title>
        <slot name="text"> </slot>
        <v-text-field
          label="Email"
          name="email"
          prepend-icon="mdi-account"
          type="text"
          :rules="rules.email"
          v-model="email"
          :disabled="isForced"
        ></v-text-field>
        <v-text-field
          id="password"
          label="Password"
          name="password"
          :rules="rules.password"
          prepend-icon="mdi-lock"
          type="password"
          v-model="password"
        ></v-text-field>
        <p class="body-2 red--text" v-if="errorMessage">{{ errorMessage }}</p>
      </v-card-text>
      <v-card-subtitle class="ma-0 pa-0 ml-2 pb-2">
        <a
          :href="`https://${subdomain}.arist.co/account-recovery`"
          class="remove-link pa-0 ma-0"
          target="_blank"
        >
          Forgot password?
        </a>
      </v-card-subtitle>
      <slot name="actions" :on="{ click: onSubmit, disabled: !valid }">
        <v-card-actions class="mt-0 pa-4">
          <v-btn
            color="grey"
            text
            dark
            min-width="80px"
            @click="$emit('signup')"
            >Sign up</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!valid"
            color="primary"
            min-width="100px"
            type="submit"
            depressed
            @click="onSubmit"
            >Sign in</v-btn
          >
        </v-card-actions>
      </slot>
    </v-card>
  </v-form>
</template>
<style scoped>
.remove-link {
  text-decoration: none !important;
  color: rgba(0, 0, 0, 0.54) !important;
}
.remove-link:hover {
  text-decoration: underline !important;
  color: #2196f3 !important;
}
</style>
<script>
import userservice from "@/bin/aws/userActions";
// import bugsnagClient from "@/plugins/bugsnag";
export default {
  props: ["forceemail"],
  data() {
    return {
      valid: true,
      email: "",
      errorMessage: "",
      password: "",
      rules: {
        email: [v => !!v || "Email is required"],
        password: [v => !!v || "Password is required"]
      }
    };
  },
  mounted() {
    if (this.forceemail && `${this.forceemail}`.length > 0) {
      this.email = this.forceemail;
    }
  },
  watch: {
    forceemail() {
      if (this.forceemail && `${this.forceemail}`.length > 0) {
        this.email = this.forceemail;
      }
    }
  },
  computed: {
    isForced() {
      return !!this.forceemail;
    },
    organizationImg() {
      if (
        !this.$store.getters["getOrganization"] ||
        !this.$store.getters["getOrganization"].icon
      ) {
        return "https://images.static.arist.co/5d1315c147dda60e60b6d7b1/1567567119748_102585";
      } else {
        return this.$store.getters["getOrganization"].icon;
      }
    },
    subdomain() {
      if (
        !this.$store.getters["getOrganization"] ||
        !this.$store.getters["getOrganization"].subdomain
      ) {
        return "courses";
      } else {
        return this.$store.getters["getOrganization"].subdomain;
      }
    }
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault();
      this.$refs.form.validate();
      if (!this.email || !this.password) {
        return;
      }
      this.$store.commit("setLoading", true);
      try {
        console.log("sending signin request...");
        await userservice.signin(String(this.email), this.password);
        this.$emit("success");
      } catch (err) {
        if (!err || !err.message) {
          this.errorMessage =
            "Unknown error has occured, please reach out to support@arist.co";
          return;
        }
        this.errorMessage = `${err.message}`;
      }
      this.$store.commit("setLoading", false);
    }
  }
};
</script>
<style></style>
